export const ORDERS_RESET_STATE = 'ORDERS_RESET_STATE';
export const ORDERS_CURRENT_ITEM = 'ORDERS_CURRENT_ITEM';

export const ORDERS_REQUEST_LOADING = 'ORDERS_REQUEST_LOADING';
export const ORDERS_REQUEST_SUCCESS = 'ORDERS_REQUEST_SUCCESS';
export const ORDERS_REQUEST_FAILED = 'ORDERS_REQUEST_FAILED';

export const ORDERS_CURRENT_ACTION = 'ORDERS_CURRENT_ACTION';
export const ORDERS_RESET_ACTION = 'ORDERS_RESET_ACTION';


export const ORDERS_CANCEL_ACTION = 'ORDERS_CANCEL_ACTION';
export const ORDERS_RETURN_ACTION = 'ORDERS_RETURN_ACTION';
